import { Pipe, PipeTransform } from '@angular/core';
import { PerioHistory, Tooth } from '@libs/ui-lib';

@Pipe({
  name: 'findToothByDateAndPosition',
  standalone: true,
})
export class FindToothByDateAndPositionPipe implements PipeTransform {
  public transform(perioTreatments: PerioHistory[], position: number, date: number): Tooth {
    return perioTreatments.find((perioTreatment) => perioTreatment.date === date)!.teeth.find((tooth) => tooth.position === position)!;
  }
}
